import { createSlice } from '@reduxjs/toolkit';
import { ISettingsState } from '../../types/settings';

const initialState: ISettingsState = {
  webimAccountName: null,
  webimHost: null,
  webimLocation: null,
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
});

export const { reducer: settingsReducer } = settingsSlice;
